// **************************************************************************
// CATALOG DATASETS STATE
// Only contains operation loading states - actual data is in application/data store
// **************************************************************************
export interface CatalogDatasetsLoadingState {
    ecoLabels: boolean;
    unspsc: boolean;
}

export interface CatalogDatasetsState {
    loading: CatalogDatasetsLoadingState;
}

export const initialCatalogDatasetsState: CatalogDatasetsState = {
    loading: { ecoLabels: false, unspsc: false },
};
